<template>
  <div>
    <div v-if="!showDetails">
      <v-card-text>
        <b>توضیح ضروری: </b>
        طبق آئين نامه، تنها براي نمرات در بازه اعلام شده مي توان اعتراض ثبت
        نمود، لذا در صورتی که نمره درس در بازه اعلام شده نیست، براساس ابلاغيه
        معاونت آموزش به شماره 89/587 مورخ 89/2/22 به مسئول مدرسه مراجعه نمائيد.
      </v-card-text>
      <div class="table-title">
        <b> دوره ها</b>
      </div>
      <div v-if="isMobile">
        <app-eteraz v-for="index in history.Cycles.length" :key="index" :index="index - 1"
          :cycle="history.Cycles[index - 1]" @clicked="onClickCycleMobile">
        </app-eteraz>
      </div>
      <div v-else>
        <v-data-table :items="history.Cycles" item-key="Srl_Cycle" :headers="cycleHeaders" class="elevation-1 rounded"
          :disable-pagination="true" :hide-default-footer="true" @click:row="onClickEterazWeb" v-model="selectedRows"
          :no-data-text="tableText" :item-class="rowClass">
          <template v-slot:[`item.Srl_Cycle`]="{ }">
            <a>نمایش جزییات</a>
            <!-- <div v-else>امکان اعتراض در این بازه زمانی وجود ندارد.</div> -->
          </template>
          <template v-slot:[`item.EterazMin`]="{ item }">
            {{ item.EterazMin }} تا {{ item.EterazMax }}
          </template>
        </v-data-table>
        <div v-if="selectedCycle != -1">
          <div>
            <div class="table-title">
              <br />
              <b>لیست دروس</b>
            </div>
            <v-data-table :items="details" :headers="detailsHeaders" class="elevation-1 child"
              :disable-pagination="true" :hide-default-footer="true" :no-data-text="NODATA">
              <template v-slot:[`item.State`]="{ item }">
                <div v-if="item.State != ''">
                  {{ item.State }}
                </div>
                <!-- <div v-else-if="!cycle.CanObject">
                  امکان اعتراض در این بازه زمانی وجود ندارد.
                </div> -->
                <v-btn class="grid" v-else color="red white--text" rounded @click="showAddDialog(item)">
                  درخواست تجدید نظر
                </v-btn>
              </template>
            </v-data-table>
          </div>
          <div>
            <div class="table-title">
              <br />
              <b>درخواست های قبلی</b>
            </div>
            <v-data-table :items="eteraz" :headers="eterazHeaders" class="elevation-1 child" :disable-pagination="true"
              :hide-default-footer="true" :no-data-text="NODATA"></v-data-table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <app-detail :cycle="cycle" :details="details" :eteraz="eteraz" :selectedVahed="selectedVahed"
        @clickedVahed="onClickVahed" @showDialog="showAddDialog">
      </app-detail>
    </div>
    <app-add-dialog :show="showAdd" :course="selectedCourse" @addEteraz="addEteraz"></app-add-dialog>
  </div>
</template>

<script>
import Eteraz from "./Eteraz";
import AddEteraz from "./AddEteraz";

import Detail from "./Detail";
import { getHistory, save } from "@/api/eteraz";
import { NODATA } from "@/utils/constants";
export default {
  components: {
    appEteraz: Eteraz,
    appAddDialog: AddEteraz,
    appDetail: Detail,
  },
  data() {
    return {
      NODATA: NODATA,
      selectedCycle: -1,
      selectedVahed: -1,
      history: {
        Cycles: [],
        Details: [],
      },
      showAdd: false,
      course: null,
      cycleHeaders: [
        {
          text: "آخرین دوره مجاز به پرینت کارت",
          value: "CycleName",
          width: "40%",
        },

        {
          text: "تاریخ شروع",
          value: "D_Start",
          width: "15%",
        },
        {
          text: "تاریخ پایان",
          value: "D_End",
          width: "15%",
        },
        {
          text: "بازه اعتراض",
          value: "EterazMin",
          width: "10%",
        },
        {
          text: "",
          value: "Srl_Cycle",
          width: "20%",
          sortable: false,
        },
      ],
      detailsHeaders: [
        {
          text: "کد",
          value: "C_Title",
          width: "10%",
        },
        {
          text: "درس",
          value: "N_Title",
          width: "30%",
        },
        {
          text: "نمره",
          value: "Mark",
          width: "10%",
        },
        {
          text: "",
          value: "State",
          width: "30%",
        },
      ],
      eterazHeaders: [
        {
          text: "درس",
          value: "N_Title",
          width: "15%",
        },
        {
          text: "تاریخ درخواست",
          value: "D_DateSabtEteraz",
          width: "15%",
        },
        {
          text: "نمره قبلی",
          value: "Mark",
          width: "10%",
        },
        {
          text: "تاريخ پاسخ	",
          value: "D_DateSabtPasokh",
          width: "15%",
        },
        {
          text: "نمره جدید",
          value: "NewMark",
          width: "10%",
        },

        {
          text: "پاسخ",
          value: "Pasokh",
          width: "35%",
        },
      ],
      selectedRows: [],
      selectedCourse: null,
    };
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.getHistory();
  },
  computed: {
    showDetails() {
      return this.selectedCycle > -1;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    cycle() {
      return this.history.Cycles[this.selectedCycle];
    },
    details() {
      return this.history.Details.filter((single) => {
        return single.Srl_Cycle == this.cycle.Srl_Cycle;
      });
    },
    eteraz() {
      return this.details.filter((single) => {
        return single.Srl_Eteraz != "";
      });
    },
  },

  methods: {
    /**
     * class for selected eteraz in web mode
     */
    rowClass(item) {
      let rowClass = this.selectedRows.includes(item.Srl_Cycle)
        ? "selected"
        : "";
      return rowClass;
    },
    /**
     * user click on eteraz in mobile mode
     */
    onClickCycleMobile(index) {
      // if (this.cycle.CanObject) {


      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });

    },
    /**
     * user click on eteraz in web mode
     */
    onClickEterazWeb(row, details) {
      // if (row.CanObject) {
      let keyID = row.Srl_Cycle;
      if (!this.selectedRows.includes(keyID)) {
        this.selectedRows = [keyID];
        window.scrollTo(0, 0);
        this.$router.push({
          query: {

            index: details.index
          }
        });
      }
      // }
    },
    showAddDialog(course) {
      this.selectedCourse = course;

      this.showAdd = true;
    },
    /**
     * expand / collapse vahed in mobile mode
     */
    onClickVahed(index) {
      if (this.selectedVahed == index) {
        this.selectedVahed = -1;
      } else {
        this.selectedVahed = index;
      }
    },
    getHistory() {
      getHistory()
        .then((response) => {
          const data = response.data;
          this.history = data;
          this.$store.commit("SET_TABLE_TEXT", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    addEteraz(lesReg, token, comment) {
      this.showAdd = false;
      if (lesReg != null) {
        save(lesReg, token, comment, this.cycle.K_Cycle)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);

            if (data.Success) {
              this.getHistory();
            }
          })

          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },

  },
  watch: {

    '$route'(to, from) {
      this.selectedCycle = this.$route.query.index ?? -1;
      if (this.selectedCycle > -1) {
        this.$store.commit("SET_HEADER_TITLE", this.cycle.CycleName);
      }

    }
  }
}


</script>
